import React from 'react';
import { MonitorFilterStatus } from '@/services/enums';

type StatusFilter = MonitorFilterStatus;

interface FilterBarProps {
  symbolFilter: string;
  setSymbolFilter: (value: string) => void;
  statusFilter: StatusFilter;
  setStatusFilter: (value: StatusFilter) => void;
  autoMonitorRunning: boolean;
  autoMonitorLoading: boolean;
  onAutoMonitorClick: () => void;
}

const FilterBar: React.FC<FilterBarProps> = ({
  symbolFilter,
  setSymbolFilter,
  statusFilter,
  setStatusFilter,
  autoMonitorRunning,
  autoMonitorLoading,
  onAutoMonitorClick,
}) => {
  return (
    <div
      className="fixed left-0 right-0 z-40 bg-black/10 backdrop-blur-sm border-b border-white/10 px-4 py-2"
      style={{ top: '56px' }}
    >
      <div className="flex items-center gap-2">
        <input
          type="text"
          value={symbolFilter}
          onChange={(e) => setSymbolFilter(e.target.value)}
          placeholder="币种筛选"
          className="w-24 bg-white/10 border border-white/20 rounded-lg px-3 py-1.5 text-white text-sm placeholder-white/40 focus:outline-none focus:ring-2 focus:ring-white/30"
        />
        <select
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value as StatusFilter)}
          className="flex-1 px-3 py-1.5 bg-white/10 border border-white/20 rounded-lg text-white text-sm focus:outline-none focus:border-white/40"
        >
          <option value="all" className="bg-gray-800 text-white">
            全部
          </option>
          <option value="running" className="bg-gray-800 text-white">
            运行中
          </option>
          <option value="stopped" className="bg-gray-800 text-white">
            已停止
          </option>
        </select>
        <button
          onClick={onAutoMonitorClick}
          disabled={autoMonitorLoading}
          className={`px-4 py-1.5 rounded-lg text-sm font-medium transition-all duration-300 ${
            autoMonitorRunning
              ? 'bg-red-500/20 border border-red-500/50 text-red-300 hover:bg-red-500/30'
              : 'bg-green-500/20 border border-green-500/50 text-green-300 hover:bg-green-500/30'
          } disabled:opacity-50`}
        >
          {autoMonitorLoading ? (
            <span className="flex items-center gap-1">
              <svg className="w-4 h-4 animate-spin" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                />
              </svg>
              处理中...
            </span>
          ) : autoMonitorRunning ? (
            '停止自主监控'
          ) : (
            '自主监控'
          )}
        </button>
      </div>
    </div>
  );
};

export default FilterBar;

